import type { IPoptipTheme } from '@visactor/vchart';

export const poptip: IPoptipTheme = {
  visible: true,
  position: 'auto',
  padding: 8,
  panel: {
    visible: true,
    size: 0,
    space: 12
  }
};
